<button [disabled]="disabled" class="icon-button music-selection {{(itemIsPlayable$ | async) ? 'playable' : 'unplayable'}}" (click)="onTogglePlay($event)">
  <tun-pause-icon-v5 *ngIf="!(itemIsStarting$ | async) && itemIsPlaying$ | async" class="icon"></tun-pause-icon-v5>
  <tun-play-icon-v5 *ngIf="!(itemIsStarting$ | async) && !(itemIsPlaying$ | async)" class="icon"></tun-play-icon-v5>
  <mat-spinner *ngIf="itemIsStarting$ | async" class="music-selection-spinner"></mat-spinner>
</button>
